var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3134 39.6213L40.0547 52.8788C40.0547 52.8788 44.7697 51.4063 51.5459 53.7626C52.6859 54.1588 54.5934 52.2513 54.1972 51.1113C51.8409 44.3351 53.3134 39.6213 53.3134 39.6213Z",
    fill: "url(#paint0_linear_6867_18943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8295 17.3951C25.8795 9.34633 38.9483 9.34633 46.9983 17.3951C55.047 25.4451 55.047 38.5138 46.9983 46.5638C38.9483 54.6126 25.8795 54.6126 17.8295 46.5638C9.78078 38.5138 9.78078 25.4451 17.8295 17.3951Z",
    fill: "url(#paint1_linear_6867_18943)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3325 15.1426C45.2675 15.8063 46.16 16.5576 46.9987 17.3951C55.0475 25.4451 55.0475 38.5138 46.9987 46.5638C38.9487 54.6126 25.88 54.6126 17.83 46.5638C17.3562 46.0888 16.91 45.5976 16.4912 45.0913C24.2937 47.6263 33.2112 45.7963 39.4062 39.6013C46.0137 32.9938 47.6562 23.2888 44.3325 15.1426Z",
    fill: "#E5EEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0622 15.6275C25.0872 6.60251 39.741 6.60251 48.766 15.6275C57.791 24.6525 57.791 39.3063 48.766 48.3313C39.741 57.3563 25.0872 57.3563 16.0622 48.3313C7.03721 39.3063 7.03721 24.6525 16.0622 15.6275ZM18.7135 18.2788C26.2747 10.7175 38.5535 10.7175 46.1147 18.2788C53.676 25.84 53.676 38.1188 46.1147 45.68C38.5535 53.2413 26.2747 53.2413 18.7135 45.68C11.1522 38.1188 11.1522 25.84 18.7135 18.2788Z",
    fill: "url(#paint2_linear_6867_18943)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.696 42.2625C7.40602 33.6137 8.86102 22.8287 16.0623 15.6275C22.8248 8.86497 32.7473 7.16997 41.096 10.5425C41.156 11.3087 41.1873 12.085 41.1873 12.8687C41.1873 13.4737 41.1685 14.075 41.1323 14.6725C33.8685 11.015 24.776 12.2175 18.7135 18.2787C12.2873 24.705 11.3223 34.5387 15.821 41.9887C14.5035 42.1687 13.1585 42.2625 11.7935 42.2625H11.696Z",
    fill: "url(#paint3_linear_6867_18943)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5334 58.0537C48.3372 55.8575 48.3372 52.2962 50.5334 50.0987C52.7297 47.9025 56.2922 47.9025 58.4884 50.0987L76.6084 68.2187C77.0959 68.7062 75.7097 70.885 73.5147 73.08C71.3197 75.275 69.1409 76.6612 68.6534 76.1737L50.5334 58.0537Z",
    fill: "url(#paint4_linear_6867_18943)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5334 58.0537C48.3372 55.8575 48.3372 52.2962 50.5334 50.0987C52.7297 47.9025 56.2922 47.9025 58.4884 50.0987L74.8884 66.4987C75.3759 66.9862 73.9897 69.165 71.7947 71.36C69.5997 73.555 67.4209 74.9412 66.9334 74.4537L50.5334 58.0537Z",
    fill: "url(#paint5_linear_6867_18943)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7662 28.0438C29.7375 26.8525 30.185 25.9825 30.875 25.4725C31.96 24.6725 33.5812 24.7063 34.4612 25.6975C34.8387 26.1238 35.0575 26.7263 35.0637 27.4888C35.0787 29.3175 34.2212 30.3863 33.3812 31.4925C32.2512 32.9838 31.1225 34.5163 30.9825 37.075C30.945 37.765 31.475 38.3538 32.1637 38.3913C32.8525 38.4288 33.4425 37.9 33.48 37.2113C33.585 35.2675 34.515 34.135 35.3737 33.0025C36.5237 31.4863 37.585 29.9738 37.5637 27.4688C37.5512 25.9963 37.06 24.86 36.33 24.0375C34.625 22.1175 31.4937 21.91 29.3912 23.46C28.1312 24.39 27.215 25.93 27.2662 28.1025C27.2825 28.7925 27.8562 29.3388 28.5462 29.3225C29.235 29.3063 29.7825 28.7338 29.7662 28.0438Z",
    fill: "url(#paint6_linear_6867_18943)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1146 43.0337C32.9638 43.0337 33.6521 42.3454 33.6521 41.4962C33.6521 40.6471 32.9638 39.9587 32.1146 39.9587C31.2655 39.9587 30.5771 40.6471 30.5771 41.4962C30.5771 42.3454 31.2655 43.0337 32.1146 43.0337Z",
    fill: "url(#paint7_linear_6867_18943)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6099 10.6213L58.3599 4.37128C58.7149 3.78003 58.5237 3.01128 57.9312 2.65628C57.3399 2.30253 56.5712 2.49378 56.2162 3.08503L52.4662 9.33503C52.1112 9.92753 52.3037 10.6963 52.8949 11.05C53.4874 11.405 54.2549 11.2138 54.6099 10.6213Z",
    fill: "url(#paint8_linear_6867_18943)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5235 14.74L74.2735 4.74003C74.831 4.33378 74.9547 3.55128 74.5497 2.99378C74.1435 2.43503 73.361 2.31253 72.8035 2.71753L59.0535 12.7175C58.4947 13.1238 58.3722 13.9063 58.7772 14.4638C59.1835 15.0225 59.966 15.145 60.5235 14.74Z",
    fill: "url(#paint9_linear_6867_18943)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5912 22.4413L72.5912 19.9413C73.2612 19.7738 73.6687 19.095 73.5012 18.425C73.3337 17.7563 72.655 17.3488 71.985 17.5163L61.985 20.0163C61.3162 20.1838 60.9087 20.8625 61.0762 21.5325C61.2437 22.2013 61.9225 22.6088 62.5912 22.4413Z",
    fill: "url(#paint10_linear_6867_18943)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6867_18943",
    x1: 51.984,
    y1: 36.2501,
    x2: 48.6934,
    y2: 53.8163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6867_18943",
    x1: 17.9558,
    y1: 20.4001,
    x2: 46.8408,
    y2: 46.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6867_18943",
    x1: 38.951,
    y1: 12.4163,
    x2: 47.2935,
    y2: 49.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6867_18943",
    x1: 19.691,
    y1: 11.3587,
    x2: 30.201,
    y2: 43.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6867_18943",
    x1: 67.3547,
    y1: 58.965,
    x2: 61.3034,
    y2: 70.5912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6867_18943",
    x1: 65.7709,
    y1: 57.3812,
    x2: 60.8309,
    y2: 68.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6867_18943",
    x1: 25.3437,
    y1: 8.67206,
    x2: 33.6525,
    y2: 43.0338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6867_18943",
    x1: 27.2647,
    y1: 22.4787,
    x2: 33.6521,
    y2: 43.0337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B04B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6867_18943",
    x1: 68.5074,
    y1: 6.78753,
    x2: 53.2162,
    y2: 18.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6867_18943",
    x1: 78.3122,
    y1: -5.39038,
    x2: 53.216,
    y2: 18.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6867_18943",
    x1: 72.5312,
    y1: 5.39063,
    x2: 53.2162,
    y2: 18.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479C6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.05d5cf37878e61b084126a742f7546ba.svg";
export { ForwardRef as ReactComponent };